export const en = {
    "header": "Access",
    "error": "An error has occurred.",
    "error-deny-access": "Deny access",
    "draft-shares-header": "Draft testers",
    "draft-shares-description": "Add users by Yandex login to test the draft.",
    "draft-shares-add-placeholder": "User login",
    "draft-shares-add-button": "Add",
    "draft-shares-error-not-found": "User not found",
    "draft-shares-error-validation": "Invalid login",
    "draft-shares-empty": "No testers yet.",
    "draft-shares-user-list": "A list of users who have access to the draft. Access can be revoked at any time.",
    "public-link-header": "Public link",
    "public-link-description": "The link provides permanent access to the published agent. Generating a new link invalidates the previous one.",
    "public-link-generate-button": "Generate link",
    "public-link-update-button": "Update link",
    "public-link-rotation-warning": "The previous link is no longer valid.",
    "side-menu-sharing": "Access",
} as const;
export const ru = {
    "header": "Доступ",
    "error": "Произошла ошибка.",
    "error-deny-access": "Запретить доступ",
    "draft-shares-header": "Тестеры черновика",
    "draft-shares-description": "Добавьте пользователей по логину Яндекса для тестирования черновика.",
    "draft-shares-add-placeholder": "Логин пользователя",
    "draft-shares-add-button": "Добавить",
    "draft-shares-error-not-found": "Пользователь не найден",
    "draft-shares-error-validation": "Некорректный логин",
    "draft-shares-empty": "Тестеров пока нет.",
    "draft-shares-user-list": "Список пользователей, имеющих доступ к черновику. Доступ можно отозвать в любой момент.",
    "public-link-header": "Публичная ссылка",
    "public-link-description": "Ссылка предоставляет постоянный доступ к опубликованному агенту. При генерации новой ссылки предыдущая становится недействительной.",
    "public-link-generate-button": "Сгенерировать ссылку",
    "public-link-update-button": "Обновить ссылку",
    "public-link-rotation-warning": "Предыдущая ссылка стала недействительной.",
    "side-menu-sharing": "Доступ",
} as const;
